import { render, staticRenderFns } from "./printCFSales.vue?vue&type=template&id=ca84c674&scoped=true&"
import script from "./printCFSales.vue?vue&type=script&lang=js&"
export * from "./printCFSales.vue?vue&type=script&lang=js&"
import style0 from "./printCFSales.vue?vue&type=style&index=0&lang=less&"
import style1 from "./printCFSales.vue?vue&type=style&index=1&id=ca84c674&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca84c674",
  null
  
)

component.options.__file = "printCFSales.vue"
export default component.exports